import axios from 'axios'
import pageKeys from '../common/pagekeys'
import store from '@/store'

export default {
    async getWeeklySummary(fiscalPeriodId) {
        try
        {            
            const response = await axios.get(`WorkShiftsPlan/weekly-summary/${fiscalPeriodId}`,
            {
                headers: {
                    'page_key': pageKeys.workshifts_plan
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },  
    async getWeeklyDetails(data) {
        try
        {            
            const response = await axios.get(`WorkShiftsPlan/weekly/${store.state.selectedTeamId}/${data.fiscalYear}/${data.weekNo}`,
            {
                headers: {
                    'page_key': pageKeys.workshifts_plan
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async getWorkShifts() {
        try
        {            
            const response = await axios.get(`WorkShiftsPlan/workshifts`,
            {
                headers: {
                    'page_key': pageKeys.workshifts_plan
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async update(data) {
        try
        {            
            const response = await axios.post(`WorkShiftsPlan`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKeys.workshifts_plan 
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async updateByTeam(data, pageKey) {
        try
        {            
            const response = await axios.post(`WorkShiftsPlan/team`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async updateByTeamMembers(data, pageKey) {
        try
        {            
            const response = await axios.post(`WorkShiftsPlan/team-members`,
            {
                item: data
            },
            {
                headers: {
                    'page_key': pageKey
                }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    },
    async delete(workShiftsPlanId) {
        try
        {            
            const response = await axios.post(`WorkShiftsPlan/delete/${workShiftsPlanId}/${store.state.selectedTeamId}`,
            {},
            {
            headers: {
                'page_key': pageKeys.workshifts_plan
            }
            })                                                           
            return response
        }
        catch (error)
        {
            throw error
        }
    }
}